import { EquipmentUsageOverviewDetail } from './equipment-usage-overview-detail.model';

export interface EquipmentUsageOverview {
  equipment: string;
  equipmentName: string;
  category: string;
  altID: string;
  customerID: string;
  dispatchStartDate: Date;
  dispatchEndDate: Date;
  details: EquipmentUsageOverviewDetail[];
}
